import { DocumentType } from 'models/documents/DocumentType';
import type { EmailServiceDocumentType } from 'models/emailService/EmailServiceDocument';

// TODO: Unit test
export const translateToEmailServiceDocumentType = (type: DocumentType): EmailServiceDocumentType => {
  switch (type) {
    case 'PreConfirmation':
      return 'PreConfirmation';
    case 'TermSheet':
      return 'TermSheet';
    case 'MarketingMaterial':
      return 'MarketingMaterial';
    default:
      throw new Error(`Blotter document type '${type}' cannot be translated into a email service document type.`);
  }
};
